import type { ReactNode } from 'react';

import { SidebarHeader } from '@nesso/ui/primitives/sidebar';

export function TodaySessionsSidebar({ children }: Readonly<{ children: ReactNode }>) {
    return (
        <>
            <SidebarHeader className="px-4 pt-6 pb-0">
                <p className="text-xs uppercase font-extrabold text-muted-foreground tracking-[1px]">
                    Today&apos;s Sessions
                </p>
            </SidebarHeader>

            {children}
        </>
    );
}
